module.exports = __webpack_public_path__ + "static/media/speakers.43f5c290.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/speakers/speakers.jpg
// module id = 564
// module chunks = 0